import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { BaseModal } from 'components/UI';
import UserGroupsParents from 'components/UserGroups/UserGroupsWizard/UserGroupsParents';

const ChangeParentGroupsModal = ({ title, userGroup, steps, open, handleClick }) => {
  return (
    <BaseModal
      size="lg"
      open={open}
      maxWidth={1160}
      loading={false}
      handleClick={handleClick}
      title={title || i18n.t('user_groups.parent.edit_parent_groups')}
    >
      <UserGroupsParents center={false} step={steps.parents} currentUserGroup={userGroup} />
    </BaseModal>
  );
};

ChangeParentGroupsModal.propTypes = {
  center: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};

ChangeParentGroupsModal.defaultProps = {
  open: false,
  handleClick: () => {},
};

export default ChangeParentGroupsModal;
